import React from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Stack,
  Paper,
  Chip,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { styled, keyframes } from "@mui/material/styles";
import { motion } from "framer-motion";
import { RocketLaunch } from "@mui/icons-material";

const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;
const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;
const RotatingElement = styled(Box)(({ duration = 20 }) => ({
  animation: `${rotate} ${duration}s linear infinite`,
}));

const FinalCTA = () => {
  const GREEN_ACCENT = "#2E9E53";
  return (
    <Box
      sx={{
        // py: { xs: 5, sm: 7, md: 10, lg: 12 },
        bgcolor: "#F7F7F7",
        textAlign: "center",
      }}
    >
      {/* --- CTA SECTION WITH PARALLAX --- */}
      <Box>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <Paper
            sx={{
              p: { xs: 4, md: 10 },
              // borderRadius: 8,
              background:
                "linear-gradient(135deg, #2E9E53 0%, #45B7A0 50%, #0B4064 100%)",
              textAlign: "center",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Animated Background */}
            <RotatingElement duration={60}>
              <Box
                sx={{
                  position: "absolute",
                  top: -200,
                  right: -200,
                  width: 400,
                  height: 400,
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.1)",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: -200,
                  left: -200,
                  width: 400,
                  height: 400,
                  borderRadius: "50%",
                  background: "rgba(255,255,255,0.1)",
                }}
              />
            </RotatingElement>

            <Box sx={{ position: "relative", zIndex: 2 }}>
              <motion.div
                animate={{ scale: [1, 1.1, 1] }}
                transition={{ repeat: Infinity, duration: 2 }}
              >
                <Box
                  sx={{
                    width: 100,
                    height: 100,
                    borderRadius: "50%",
                    bgcolor: "rgba(255,255,255,0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    mb: 4,
                  }}
                >
                  <RocketLaunch sx={{ fontSize: 50, color: "#fff" }} />
                </Box>
              </motion.div>

              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: "2rem", md: "3.5rem" },
                  fontWeight: 800,
                  color: "#fff",
                  mb: 2,
                }}
              >
                {/* Ready to Transform Your Business? */}
                {/* Ready to Transform<br></br> Your Dealer Network? */}
                Ready to Build Something Powerful?
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  color: "rgba(255,255,255,0.9)",
                  mb: 4,
                  maxWidth: "700px",
                  mx: "auto",
                }}
              >
                {/* Join 100+ manufacturers who've already digitized their B2B
                operations. Start your journey today. */}
                Whether you need a custom ERP, a full-stack web app, or a complete tech solution — BizBridge has the expertise to deliver it. Let's talk.
              </Typography>

              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                justifyContent="center"
              >
                <Button
                  variant="contained"
                  size="large"
                  // onClick={handleDialogOpen}
                  component={Link}
                  to="/login"
                  sx={{
                    bgcolor: "#fff",
                    color: GREEN_ACCENT,
                    px: 6,
                    py: 2,
                    borderRadius: "50px",
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    "&:hover": {
                      bgcolor: "#f0f0f0",
                      transform: "scale(1.05)",
                    },
                    transition: "all 0.3s",
                  }}
                >
                  {/* Get Started Free */}
                   Start Your Journey
                </Button>
                <Button
                  variant="outlined"
                  size="large"
                  component={Link}
                  to="/contact"
                  sx={{
                    color: "#fff",
                    borderColor: "#fff",
                    px: 6,
                    py: 2,
                    borderRadius: "50px",
                    fontSize: "1.1rem",
                    borderWidth: 2,
                    "&:hover": {
                      borderColor: "#fff",
                      borderWidth: 2,
                      bgcolor: "rgba(255,255,255,0.1)",
                    },
                  }}
                >
                  Schedule Demo
                </Button>
              </Stack>
            </Box>
          </Paper>
        </motion.div>
      </Box>
    </Box>
  );
};

export default FinalCTA;
